module.exports = __webpack_public_path__ + "436adcd23add73e58d1dd21d85fee95d.svg";